import { useContext, useState } from 'react';
import UserContext from '../../contexts/userContext.js';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';

import { focusOnQueryInput, formatISODatetime, retryFetch, scrollToBottom, scrollToTop } from "../../utils.js";
import "../../styles/ConversationList.css" 

export const ConversationCard = ({conversationOverview, setShowConversationHistory}) => {
    const { userContext, setUserContext, setAccount } = useContext(UserContext);
    
    const [ isLoading, setIsLoading ] = useState(false);
    const [ isDeleting, setIsDeleting ] = useState(false);

    const conversationid = conversationOverview.conversationid
    const selectedConversationid = userContext.conversationOverview && userContext.conversationOverview.conversationid;
    const isSelected = conversationid === selectedConversationid;
    const hasSummary = conversationOverview.summary;

    const deleteConversation = (retryCount, {event, conversationOverview}) => {
        if (event) {
            event.stopPropagation();
        }
        
        const documentid = userContext.document.documentid
        const conversationid = conversationOverview.conversationid;
        console.log('deleting conversation', conversationid);
        setIsDeleting(true);
        
        const apiGatewayInvokeUrl = process.env[`REACT_APP_API_GATEWAY_INVOKE_URL__${process.env["REACT_APP_DEPLOYMENT_TYPE"]}`]
        const endpoint = `${apiGatewayInvokeUrl}/doc/${documentid}/${conversationid}`;
        const params = {
            method: "DELETE",
            headers: {
                "Authorization": `Bearer ${userContext.account.idToken}`
            }
        };
        
        fetch(endpoint, params)
            .then(response => response.json())
            .then(responseJson => {
                const tempUserContext = {...userContext};
                const tempDocument = tempUserContext.document;
                tempDocument.conversations = tempDocument.conversations.filter(c => c.conversationid !== responseJson.conversationid);
                setUserContext(tempUserContext);
                setIsDeleting(false);
                setIsLoading(false);
            })
            .catch(e => {
                console.log('error deleting conversation', e);
                retryFetch(userContext, setAccount, retryCount, deleteConversation, {conversationOverview})
            });
    }

    return (
        <a 
            key={conversationid}
            onClick={() => getConversation(0, {userContext, setUserContext, setAccount, conversationOverview, setIsLoading, setShowConversationHistory})}
            className="no-text-decoration"
        >
            <Card className="m-2">
                <InputGroup className="conversation-header a8-light-gray-background">
                    <Button
                        variant="light"
                        style={{"borderBottomLeftRadius": "0px"}}
                        className='a8-light-gray-background'
                        onClick={(event) => deleteConversation(0, {event, conversationOverview})}
                    > 
                        {isDeleting ? (
                            <Spinner animation="border" size="sm" className='a8-blue' />
                        ) : (
                            <i className="bi-trash" />
                        )}
                    </Button>
                    
                    <Form.Control 
                        value={formatISODatetime(conversationOverview.created)}
                        className="a8-light-gray-background no-border no-text-decoration"
                        readOnly
                    />
                    
                    {isSelected ? (
                        <Button
                            variant="success"
                            className="a8-orange-background"
                            style={{"borderBottomRightRadius": "0px"}}
                        >
                            <i className="bi-check2-square" />
                        </Button>
                    ) : (
                        <Button variant="light" style={{"borderBottomRightRadius": "0px"}} disabled>
                            {isLoading ? (
                                <Spinner animation="border" size="sm" className="a8-blue" />
                            ) : (
                                <i className="a8-light-gray-background bi-square" />
                            )}
                        </Button>
                    )}
                </InputGroup>

                <div className="conversation-summary">
                    {hasSummary ? (
                        <i>{conversationOverview.summary.trim()}</i>
                    ) : (
                        <i className="px-2">New conversation</i>
                    )}
                </div>
            </Card>
        </a>
    )
};

export const getConversation = (retryCount, { userContext, setUserContext, setAccount, conversationOverview, generateConversationOverview, setShowConversationHistory, setIsLoading }) => {
    const documentid = userContext.document.documentid;
    const conversationid = conversationOverview.conversationid;
    console.log('getting conversation', conversationid);

    if (setIsLoading) {
        setIsLoading(true);
    }

    const apiGatewayInvokeUrl = process.env[`REACT_APP_API_GATEWAY_INVOKE_URL__${process.env["REACT_APP_DEPLOYMENT_TYPE"]}`];
    const endpoint = `${apiGatewayInvokeUrl}/doc/${documentid}/${conversationid}`;
    const params = {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${userContext.account.idToken}`
        }
    };

    fetch(endpoint, params)
        .then(response => response.json())
        .then(conversation => {
            const tempUserContext = { ...userContext };

            if (setIsLoading) { //if called from within ConversationList rather than generateResponseStreaming
                tempUserContext.conversationOverview = conversationOverview;
                tempUserContext.showConversationHistory = false;

                scrollToTop();
                scrollToBottom(1200);
                focusOnQueryInput(1000);
            }
            tempUserContext.conversation = conversation;
            setUserContext(tempUserContext);

            if (generateConversationOverview) { //if called from generateResponseStreaming rather than from within ConversationList
                generateConversationOverview(tempUserContext, setUserContext, documentid, conversationid);
            }

            if (setShowConversationHistory) {
                setShowConversationHistory(false);
            }

            if (setIsLoading) {
                setIsLoading(false);
            }
        })
        .catch(e => {
            console.log('error selecting conversation', e);
            retryFetch(userContext, setAccount, retryCount, getConversation, { userContext, setUserContext, setAccount, setIsLoading, conversationOverview, generateConversationOverview });
        });
};
